export type ShareExpiryUnit = "minutes" | "hours" | "days";

export const DEFAULT_SHARE_EXPIRY_AMOUNT = 30;
export const DEFAULT_SHARE_EXPIRY_UNIT: ShareExpiryUnit = "days";

export const SHARE_EXPIRY_UNITS: { value: ShareExpiryUnit; label: string }[] = [
  { value: "minutes", label: "Minutes" },
  { value: "hours", label: "Hours" },
  { value: "days", label: "Days" },
];

export type ShareLinkExpiryPayload = {
  expiryAmount: number;
  expiryUnit: ShareExpiryUnit;
};

/** "3 days", "1 hour", "45 minutes": how a chosen expiry reads back to the studio. */
export function shareLinkExpiryLabel(amount: number, unit: ShareExpiryUnit): string {
  const n = Math.floor(Number(amount));
  if (!Number.isFinite(n) || n < 1) return "";
  const word = unit === "days" ? "day" : unit === "hours" ? "hour" : "minute";
  return `${n} ${word}${n === 1 ? "" : "s"}`;
}

export function shareLinkExpiryPayload(
  amount: number,
  unit: ShareExpiryUnit
): ShareLinkExpiryPayload | null {
  const n = Math.floor(Number(amount));
  if (!Number.isFinite(n) || n < 1) {
    return null;
  }
  if (unit !== "minutes" && unit !== "hours" && unit !== "days") {
    return null;
  }
  return { expiryAmount: n, expiryUnit: unit };
}
